import { render, staticRenderFns } from "./composeMail.vue?vue&type=template&id=58fb82f9&scoped=true&"
import script from "./composeMail.vue?vue&type=script&lang=js&"
export * from "./composeMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fb82f9",
  null
  
)

export default component.exports